import ChatInterface from './components/ChatInterface'
import React from 'react'

function App() {
  return <ChatInterface />;
}

export default App;
